import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message, Space } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";

const EmployeesPage = () => {
  const [employees, setEmployees] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentEmployee, setCurrentEmployee] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    // Моковые данные сотрудников (упрощенные)
    const mockEmployees = [
      {
        id: "1",
        fullName: "Иванов Иван Иванович",
        phone: "+7 (999) 123-45-67",
        telegram: "@ivanovii",
      },
      {
        id: "2",
        fullName: "Петрова Анна Сергеевна",
        phone: "+7 (911) 987-65-43",
        telegram: "@petrovaas",
      },
    ];
    setEmployees(mockEmployees);
  }, []);

  const columns = [
    {
      title: "ФИО",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Телефон",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Телеграм",
      dataIndex: "telegram",
      key: "telegram",
    },
    {
      title: "Действия",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          />
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          />
        </Space>
      ),
    },
  ];

  const showModal = () => {
    setCurrentEmployee(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleEdit = (employee) => {
    setCurrentEmployee(employee);
    form.setFieldsValue(employee);
    setIsModalVisible(true);
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: "Удалить сотрудника?",
      content: "Вы уверены, что хотите удалить этого сотрудника?",
      okText: "Да",
      cancelText: "Нет",
      onOk: () => {
        setEmployees(employees.filter((emp) => emp.id !== id));
        message.success("Сотрудник удален");
      },
    });
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (currentEmployee) {
          // Редактирование
          setEmployees(
            employees.map((emp) =>
              emp.id === currentEmployee.id ? { ...emp, ...values } : emp,
            ),
          );
          message.success("Данные сотрудника обновлены");
        } else {
          // Добавление
          const newEmployee = {
            ...values,
            id: String(employees.length + 1),
          };
          setEmployees([...employees, newEmployee]);
          message.success("Сотрудник добавлен");
        }
        setIsModalVisible(false);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div style={{ padding: "24px" }}>
          <div style={{ marginBottom: "16px" }}>
            <Button type="primary" icon={<PlusOutlined />} onClick={showModal}>
              Добавить сотрудника
            </Button>
          </div>

          <Table
            columns={columns}
            dataSource={employees}
            rowKey="id"
            bordered
          />

          <Modal
            title={
              currentEmployee
                ? "Редактировать сотрудника"
                : "Добавить сотрудника"
            }
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={currentEmployee ? "Обновить" : "Добавить"}
            cancelText="Отмена"
          >
            <Form form={form} layout="vertical" name="employee_form">
              <Form.Item
                name="fullName"
                label="ФИО"
                rules={[{ required: true, message: "Пожалуйста, введите ФИО" }]}
              >
                <Input placeholder="Иванов Иван Иванович" />
              </Form.Item>

              <Form.Item
                name="phone"
                label="Телефон"
                rules={[
                  { required: true, message: "Пожалуйста, введите телефон" },
                ]}
              >
                <Input placeholder="+7 (XXX) XXX-XX-XX" />
              </Form.Item>

              <Form.Item name="telegram" label="Телеграм">
                <Input placeholder="@username" addonBefore="@" />
              </Form.Item>
            </Form>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default EmployeesPage;
